import { navigate } from "gatsby";
import axios from "axios";
import { serverUri } from "../api/serverUri";
export const isBrowser = () => typeof window !== "undefined";
export const getUser = () =>
  isBrowser() && window.localStorage.getItem("strapiUser")
    ? JSON.parse(window.localStorage.getItem("strapiUser"))
    : {};
const setUser = (user) =>
  window.localStorage.setItem("strapiUser", JSON.stringify(user));
export const clearSession = () => {
  if (!isBrowser()) return;
  window.localStorage.removeItem("token");
  window.localStorage.removeItem("strapiUser");
};
let redirectingToLogin = false;

export const redirectToLogin = (returnTo) => {
  if (!isBrowser()) return;
  if (redirectingToLogin) return;
  const path = window.location.pathname || "";
  if (path.includes("/login")) return;
  redirectingToLogin = true;
  if (returnTo) window.localStorage.setItem("returnAfterLogin", returnTo);
  else if (path && path !== "/app/login") {
    window.localStorage.setItem("returnAfterLogin", path + (window.location.search || ""));
  }
  clearSession();
  navigate("/app/login");
};

/** True si la respuesta indica sesión admin inválida/vencida. */
export const isUnauthorizedError = (error) => {
  const status = error?.response?.status ?? error?.status;
  return status === 401 || status === 403;
};

/**
 * Si el error es 401/403, cierra sesión y manda al login.
 * Devuelve true cuando redirigió (el caller no debe mostrar otro error genérico).
 */
export const handleUnauthorized = (error, returnTo) => {
  if (!isUnauthorizedError(error)) return false;
  redirectToLogin(returnTo);
  return true;
};
// if (email === `john@email.com` && password === `pass`) {
// navigate("/app/profile");

export const handleLogin = (user) => {
  axios
    .post(`${serverUri}/admin/login`, user)
    .then((response) => {
      console.log(response);
      if (response.status === 200) {
        redirectingToLogin = false;
        setUser({
          username: user.email,
          name: user.email,
          email: user.email,
        });
        window.localStorage.setItem("token", response.data.data.token);
        const returnTo = window.localStorage.getItem("returnAfterLogin") || "/app/profile";
        window.localStorage.removeItem("returnAfterLogin");
        navigate(returnTo);
        return true;
      }
      return false;
    })
    .catch((error) => console.log("An error occurred:", error.response));

  // if (authenticateUser(user)) {
  //   setUser({
  //     username: user.email,
  //     name: user.email,
  //     email: user.email,
  //   });
  //   navigate("/app/profile");
  //   return true;
  // }
  // return false;
};

export const isLoggedIn = () => {
  if (!isBrowser()) return false;
  const user = getUser();
  const token = window.localStorage.getItem("token");
  return Boolean(user.username && token);
};
export const logout = (callback) => {
  clearSession();
  callback();
};
